<template>
  <!-- <Layout /> -->
  <router-view />
</template>

<script setup>
// import Layout from "./components/Layout.vue";
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow: hidden;
}
</style>
